import type { DeleteIndicatorResultsMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useTRPC } from '@/utils/trpc';

/**
 * Maps TRPC mutation response to match the GraphQL mutation structure
 */
const mapTrpcResponseToGraphQL = (
  numIds: number
): DeleteIndicatorResultsMutation => ({
  delete_indicator_result: {
    __typename: 'indicator_result_mutation_response',
    affected_rows: numIds,
  },
});

export const useDeleteIndicatorResultsTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.indicator.deleteResults.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey:
            trpc.frontend.indicator.indicatorResultsByIndicatorId.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.indicator.indicatorById.queryKey(),
        });
      },
    }),
  });

  return {
    deleteIndicatorResults: async (variables: {
      ids: string[];
    }): Promise<DeleteIndicatorResultsMutation> => {
      await mutation.mutateAsync(variables);

      return mapTrpcResponseToGraphQL(variables.ids.length);
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
